<script>
    import PlanType from '../comparator/PlanType.svelte';
    import {
        CONSTANTS,
        MOVIL_CATEGORIES,
        NEGOCIOS_CATEGORIES,
    } from '../comparator/utils/constant';
    import PlanTypeSky from '../comparator/PlanTypeSky.svelte';
    import { store } from '../../Store.svelte';
    import OfferCategorySelector from './OfferCategorySelector.svelte';
    import OfferCategorySelectorOffnet from './OfferCategorySelectorOffnet.svelte';
    import { onMount } from 'svelte';

    export let plansObject = {
        plans: [],
        category: '',
    };

    export let onSelectionChange = () => {};

    export let toggleEditAddress = () => {};

    export let onChangeMovilMobileData = () => {};
    export let selectedMovilMobileData = '';

    export let onChangeMovilTerm = () => {};
    export let selectedMovilTerm = '';

    export let onChangeCheckedCombos = () => {};
    export let checkedCombos = false;

    export let isOffnet = false;

    let isNegocios = NEGOCIOS_CATEGORIES.has(plansObject.category);
    let selectedServices = [];
    let offersDisplayRef = null;
    let showArrows = false;

    $: shouldDisplayMovil =
        plansObject.category != CONSTANTS.CATEGORY_MOVIL &&
        MOVIL_CATEGORIES.has(plansObject.category);

    $: shouldDisableCombo = NEGOCIOS_CATEGORIES.has(plansObject.category);

    function handleSelectionChange(event) {
        selectedServices = event.detail;
        onSelectionChange(event);
    }

    function fromSelectedLabelToText(label) {
        if (label === 'internet') return 'internet';
        if (label === 'tv') return 'izzi tv';
        if (label === 'movil') return 'móvil';
        return '';
    }

    function checkForScrollbar() {
        if (offersDisplayRef) {
            showArrows =
                offersDisplayRef.scrollWidth > offersDisplayRef.clientWidth;
        }
    }

    onMount(() => {
        checkForScrollbar();

        window.addEventListener('resize', checkForScrollbar);

        return () => {
            window.removeEventListener('resize', checkForScrollbar);
        };
    });

    $: if (plansObject.plans) {
        setTimeout(checkForScrollbar, 0);
    }

    const SCROLL_AMOUNT = 300;
    const SCROLL_AMOUNT_SKY = 350;
    function scrollRight(isSkyScroll) {
        if (offersDisplayRef) {
            offersDisplayRef.scrollTo({
                left: !isSkyScroll
                    ? offersDisplayRef.scrollLeft + SCROLL_AMOUNT
                    : offersDisplayRef.scrollLeft + SCROLL_AMOUNT_SKY,
                behavior: 'smooth',
            });
        }
    }

    function scrollLeft(isSkyScroll) {
        if (offersDisplayRef) {
            offersDisplayRef.scrollTo({
                left: !isSkyScroll
                    ? offersDisplayRef.scrollLeft - SCROLL_AMOUNT
                    : offersDisplayRef.scrollLeft - SCROLL_AMOUNT_SKY,
                behavior: 'smooth',
            });
        }
    }
</script>

<div class="offer-container">
    {#if !$store.requestedServices.isSky}
        <div class="offer-header">
            <div>
                <h2 class="offer-title">elige y personaliza tu solución</h2>
                <h3 class="offer-subtitle">
                    disfruta de los paquetes mas completos
                </h3>
            </div>
            <div class="offer-address-box">
                <div class="offer-address-title">
                    Dirección <button on:click={toggleEditAddress}
                        >editar</button
                    >
                </div>
                <span class="offer-address-text">
                    {$store.requestedAddress.addressString}, {$store
                        .requestedAddress.postalCode}
                </span>
            </div>
        </div>
    {/if}
    <div class="offer-tab-content">
        {#if !$store.requestedServices.isSky}
            <div class="offer-content">
                {#if isOffnet}
                    <OfferCategorySelectorOffnet
                        disableCombo={shouldDisableCombo}
                        onSelectionChange={handleSelectionChange}
                        {onChangeMovilMobileData}
                        {selectedMovilMobileData}
                        {onChangeMovilTerm}
                        {selectedMovilTerm}
                        {onChangeCheckedCombos}
                        {checkedCombos}
                    />
                {:else}
                    <OfferCategorySelector
                        disableCombo={shouldDisableCombo}
                        onSelectionChange={handleSelectionChange}
                        {onChangeMovilMobileData}
                        {selectedMovilMobileData}
                        {onChangeMovilTerm}
                        {selectedMovilTerm}
                        {onChangeCheckedCombos}
                        {checkedCombos}
                        {isNegocios}
                    />
                {/if}
            </div>
        {/if}
        {#if plansObject.plans.length === 0 && selectedServices.length > 0}
            <div class="offer-not-available">
                <div class="not-available-text">
                    <p class="not-available-title">
                        Por el momento no existen paquetes disponibles para:
                        <span>
                            {selectedServices
                                .map(fromSelectedLabelToText)
                                .join(' + ')}
                        </span>
                    </p>
                    <p class="not-available-description">
                        Intenta hacer otra búsqueda y revisa otras opciones que
                        tenemos para ti
                    </p>
                </div>
                <div class="support-section">
                    <p class="support-title">¿Necesitas ayuda?</p>
                    <div class="support-options">
                        <a class="support-option-item" href="tel:+528006077070">
                            <img src="/assets/img/icons/call.svg" alt="call" />
                            <div>
                                <p>¡Llámanos!</p>
                                <p>800 607 7070</p>
                            </div>
                        </a>
                        <div class="support-option-divider" />
                        <a
                            href="https://api.whatsapp.com/send/?phone=5215589003103"
                            class="support-option-item"
                        >
                            <img
                                src="/assets/img/icons/whatsapp-black.svg"
                                alt="whatsapp"
                            />
                            <p>WhatsApp</p>
                        </a>
                    </div>
                </div>
            </div>
        {:else if plansObject.plans.length === 0}
            <div class="offer-not-selected">
                <p>Selecciona un servicio</p>
                <span>
                    Selecciona un servicio para explorar los paquetes
                    disponibles para ti.
                </span>
            </div>
        {:else if plansObject.category === CONSTANTS.CATEGORY_SKY}
            <div class="offers-display-container">
                {#if showArrows}
                    <div class="offers-display-arrow-container">
                        <button
                            class="offer-display-arrow offers-display-arrow-left"
                            on:click={() => {
                                scrollLeft(true);
                            }}
                        >
                            <svg class="icon">
                                <use
                                    xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-left"
                                />
                            </svg>
                        </button>
                        <button
                            class="offer-display-arrow offers-display-arrow-right"
                            on:click={() => {
                                scrollRight(true);
                            }}
                        >
                            <svg class="icon">
                                <use
                                    xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-right"
                                />
                            </svg>
                        </button>
                    </div>
                {/if}
                <div
                    class="offers-display justify-content-center"
                    bind:this={offersDisplayRef}
                >
                    {#each plansObject.plans as item}
                        {#key [item.paqId]}
                            <PlanTypeSky
                                plan={item}
                                category={plansObject.category}
                            />
                        {/key}
                    {/each}
                </div>
            </div>
        {:else}
            <div class="offers-display-container">
                {#if showArrows}
                    <div class="offers-display-arrow-container">
                        <button
                            class="offer-display-arrow offers-display-arrow-left"
                            on:click={() => {
                                scrollLeft(false);
                            }}
                        >
                            <svg class="icon">
                                <use
                                    xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-left"
                                />
                            </svg>
                        </button>
                        <button
                            class="offer-display-arrow offers-display-arrow-right"
                            on:click={() => {
                                scrollRight(false);
                            }}
                        >
                            <svg class="icon">
                                <use
                                    xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-right"
                                />
                            </svg>
                        </button>
                    </div>
                {/if}
                <div class="offers-display" bind:this={offersDisplayRef}>
                    {#each plansObject.plans as item}
                        {#key [item.paqId, selectedMovilTerm, selectedMovilMobileData, checkedCombos]}
                            <PlanType
                                plan={item}
                                category={plansObject.category}
                                selectedMovilMobileData={shouldDisplayMovil &&
                                    selectedMovilMobileData}
                                selectedMovilTerm={shouldDisplayMovil &&
                                    selectedMovilTerm}
                                {checkedCombos}
                            />
                        {/key}
                    {/each}
                </div>
            </div>
        {/if}
    </div>
</div>
